import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import TenableVulnerabilityManagementMappingFormV2 from "./TenableVulnerabilityManagementMappingFormV2";
import TenableVulnerabilityManagementCredentialsForm from "./TenableVulnerabilityManagementCredentialsForm";
import ContentOverlay from "components/ContentOverlay";
import { map, split } from "lodash";

export default function TenableVulnerabilityManagementConfigListing(props) {
  const extraColumns = useMemo(
    () => [
      {
        dataIndex: "assetTagKey",
        title: "Asset Tag Key and Value",
        width: 240,
        render: (tagKey, record) => {
          const tagValues = split(record.assetTagValue, ";");
          const renderName = map(split(tagKey, ","), (item, index) =>
            !tagKey
              ? "All"
              : `${item} - [${!tagValues ? "All" : split(tagValues[index], ",").join(", ")}]`,
          );

          const content = renderName.map((item) => <p>{item}</p>);

          return <ContentOverlay content={content} minHeight={40} />;
        },
      }
    ],
    []
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={TenableVulnerabilityManagementMappingFormV2}
      triggerModifyParam={triggerModifyParam}
      CredentialsForm={TenableVulnerabilityManagementCredentialsForm}
      displayComponentName="Asset Tag"
      extraColumns={extraColumns}
    />
  );
}

const triggerModifyParam = (record) => {
  return {
    toolConfigId: record.id,
  };
};
